import { StatusBadge } from "@/components/PageHeader";

export default function Pipeline({ items, statuses, onOpen, labelKey, subKey }) {
  const byStatus = (st) => items.filter((i) => (i.status || statuses[0]) === st);
  return (
    <div className="overflow-x-auto pb-4 -mx-1" data-testid="pipeline-board">
      <div className="flex gap-4 min-w-max px-1">
        {statuses.map((st) => {
          const col = byStatus(st);
          return (
            <div key={st} className="w-[280px] shrink-0" data-testid={`pipeline-col-${st}`}>
              <div className="flex items-center justify-between px-1 mb-2.5">
                <span className="text-xs font-bold uppercase tracking-wider text-muted-foreground">{st.replace(/_/g, " ")}</span>
                <span className="text-xs font-semibold bg-secondary rounded-full px-2 py-0.5">{col.length}</span>
              </div>
              <div className="space-y-2.5 bg-muted/40 rounded-xl p-2 min-h-[120px]">
                {col.map((it) => (
                  <button key={it.id} onClick={() => onOpen(it)} data-testid="pipeline-card"
                    className="w-full text-left rounded-lg bg-card border border-border p-3.5 hover:border-primary/50 hover:shadow-sm transition-all">
                    <div className="flex items-start justify-between gap-2">
                      <span className="font-semibold text-sm leading-tight">{it[labelKey] || "Untitled"}</span>
                      {it.priority && <StatusBadge value={it.priority} />}
                    </div>
                    {subKey && it[subKey] && <p className="text-xs text-muted-foreground mt-1 truncate">{it[subKey]}</p>}
                    {it.reference_no && <p className="text-[11px] text-primary font-medium mt-1.5">{it.reference_no}</p>}
                  </button>
                ))}
                {col.length === 0 && <p className="text-center text-xs text-muted-foreground py-4">—</p>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
